import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SettingsPage } from '../../contexts/settings-modal-context';
import { SettingsTabs } from '../../components/settings-tabs';
import { Header } from '../../components/layout/header';
import { AboutUs } from '../settings/about-us';
import { PrivacyPolicy } from '../settings/privacy-policy';
import { TermsOfUse } from '../settings/terms-of-use';
import { ROUTE_PATH } from '../../routes/route-paths';
import { tabParamToPage, pageToTabParam } from '../../utils/settings-utils';

const INFO_PAGE_MAP: Record<string, SettingsPage> = {
  'about us': SettingsPage.aboutUs,
  'privacy policy': SettingsPage.privacyPolicy,
  'terms of use': SettingsPage.termsOfUse,
};

export const InfoSettingsPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState<SettingsPage>(SettingsPage.aboutUs);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    const page = tabParamToPage(tabParam, INFO_PAGE_MAP, SettingsPage.aboutUs);
    setCurrentPage(page);
  }, [location.search]);

  const handleTabChange = useCallback(
    (page: SettingsPage) => {
      setCurrentPage(page);
      history.replace(`${ROUTE_PATH.SETTINGS_INFO}?tab=${pageToTabParam(page)}`);
    },
    [history],
  );

  const tabs = useMemo(
    () => [
      { page: SettingsPage.aboutUs, label: 'About Us' },
      { page: SettingsPage.privacyPolicy, label: 'Privacy Policy' },
      { page: SettingsPage.termsOfUse, label: 'Terms of Use' },
    ],
    [],
  );

  const renderPage = () => {
    switch (currentPage) {
      case SettingsPage.aboutUs:
        return <AboutUs />;
      case SettingsPage.privacyPolicy:
        return <PrivacyPolicy />;
      case SettingsPage.termsOfUse:
        return <TermsOfUse />;
      default:
        return <AboutUs />;
    }
  };

  return (
    <>
      <Header />
      <div className="bg-whiteSmoke flex min-h-screen flex-col pt-[76px]">
        <SettingsTabs
          tabs={tabs}
          activeTab={currentPage}
          basePath={ROUTE_PATH.SETTINGS_INFO}
          onTabChange={handleTabChange}
        />
        <div className="flex-1 overflow-auto">{renderPage()}</div>
      </div>
    </>
  );
};
